class RunningHelpers {
    static printTime(time, showHours) {
        let hours = time.getHours();
        let minutes = time.getMinutes();
        let seconds = time.getSeconds();
        let result = "";
        if (showHours) {
            result += hours.toString().padStart(2, '0') + ":";
        }
        result += minutes.toString().padStart(2, '0') + ":" + seconds.toString().padStart(2, '0');
        return result;
    }
}
RunningHelpers.MileInKm = 1.609344;
//# sourceMappingURL=RunningHelpers.js.map